import SvgIcon from '@mui/material/SvgIcon';
import type { SvgIconProps } from '@mui/material/SvgIcon';

// Lightweight Rolodex/Contact-card style icon to echo mdi/js rolodex
export default function MdiRolodexIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      {/* Card outline */}
      <rect x="4" y="5" width="16" height="14" rx="2" ry="2" fill="none" stroke="currentColor" strokeWidth="2" />
      {/* Avatar circle */}
      <circle cx="9" cy="12" r="2.5" fill="none" stroke="currentColor" strokeWidth="2" />
      {/* Text lines */}
      <path d="M13 10h6M13 14h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      {/* Tab accents at top to hint rolodex dividers */}
      <path d="M8 5v2M16 5v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
}

